(() => {
  if (window.HorusBondsQuickAdd) return;
  let busy = false;
  const cards = new Set();
  const silverFinishes = new Set(['silver','argento','argent','argenté','prata','argint','plata','plateado','silber']);
  const unlock = () => document.documentElement.classList.toggle('hq-options-open',Boolean(document.querySelector('[data-hq-dialog][open]')));
  const init = card => {
    if (card.dataset.hqReady) return;
    card.dataset.hqReady = 'true';
    const dialog = card.querySelector('[data-hq-dialog]');
    const trigger = card.querySelector('[data-hq-open]');
    const form = card.querySelector('[data-hq-form]');
    const controls = [...form.querySelectorAll('[data-hq-option]')];
    const variants = JSON.parse(card.querySelector('[data-hq-variants]').textContent);
    const strings = JSON.parse(card.querySelector('[data-hq-strings]').textContent);
    const button = form.querySelector('[data-hq-add]');
    const status = form.querySelector('[data-hq-status]');
    const variantInput = form.querySelector('[data-hq-variant]');
    const quantity = form.querySelector('[data-hq-quantity]');
    const pictures = [...card.querySelectorAll('[data-hq-image],[data-hq-modal-image]')];
    const prices = [...card.querySelectorAll('[data-hq-price],[data-hq-modal-price]')];
    const links = [...card.querySelectorAll('[data-hq-link]')];
    const sample = card.dataset.moneyExample || '';
    const formatter = new Intl.NumberFormat(card.dataset.locale || 'en',{style:'currency',currency:card.dataset.currency || 'EUR'});
    const money = cents => {
      if (sample.includes('1,00')) {
        const [prefix,suffix] = sample.split('1,00');
        return prefix + new Intl.NumberFormat('de-DE',{minimumFractionDigits:2,maximumFractionDigits:2}).format(cents/100) + suffix;
      }
      return formatter.format(cents/100);
    };
    const selectedVariant = () => variants.find(variant => controls.every(control => control.value && variant.options[Number(control.dataset.hqOption)] === control.value));
    const sync = () => {
      const variant = selectedVariant();
      const finish = controls.find(control => control.dataset.hqOption === '0')?.value || variants[0]?.options[0] || '';
      const source = card.dataset[silverFinishes.has(finish.toLowerCase().trim()) ? 'silverImage' : 'goldImage'];
      pictures.forEach(image => { if (source && image.getAttribute('src') !== source) image.src = source; });
      const matchingFinish = variants.find(item => item.options[0] === finish);
      prices.forEach(price => price.textContent = money((variant || matchingFinish || variants[0]).price));
      const label = form.querySelector('[data-hq-finish-label]');
      if (label) label.textContent = finish;
      form.querySelectorAll('[data-hq-finish]').forEach(swatch => swatch.setAttribute('aria-pressed',String(swatch.dataset.hqFinish === finish)));
      variantInput.value = variant?.id || '';
      links.forEach(link => {
        const url = new URL(link.href,location.origin);
        if (variant) url.searchParams.set('variant',variant.id); else url.searchParams.delete('variant');
        link.href = url.pathname + url.search;
      });
      trigger.disabled = busy;
      button.disabled = busy || !variant?.available;
      button.textContent = busy ? strings.adding : strings.add;
      form.querySelectorAll('[data-hq-minus],[data-hq-plus],[data-hq-quantity]').forEach(input => input.disabled = busy);
      status.textContent = variant && !variant.available ? strings.unavailable : '';
      return variant;
    };
    const entry = {card,sync,dialog};
    cards.add(entry);
    const setBusy = value => {
      busy = value;
      for (const item of cards) {
        if (!item.card.isConnected) { cards.delete(item); continue; }
        item.sync();
      }
      form.setAttribute('aria-busy',String(value));
    };
    const count = () => Math.max(1,Math.min(99,Math.floor(Number(quantity.value) || 1)));
    trigger.addEventListener('click',() => {
      if (busy) return;
      sync();
      pictures.forEach(image => image.loading = 'eager');
      dialog.showModal();
      unlock();
    });
    dialog.querySelector('[data-hq-close]').addEventListener('click',() => dialog.close());
    dialog.addEventListener('click',event => {
      if (event.target !== dialog) return;
      const r = dialog.getBoundingClientRect();
      if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close();
    });
    dialog.addEventListener('close',() => { unlock(); if(trigger.isConnected)trigger.focus({preventScroll:true}); });
    controls.forEach(control => control.addEventListener('change',sync));
    form.querySelectorAll('[data-hq-finish]').forEach(swatch => swatch.addEventListener('click',() => {
      if (busy) return;
      form.querySelector(`[data-hq-option="${swatch.dataset.hqIndex}"]`).value = swatch.dataset.hqFinish;
      sync();
    }));
    form.querySelector('[data-hq-minus]').addEventListener('click',() => quantity.value = Math.max(1,count()-1));
    form.querySelector('[data-hq-plus]').addEventListener('click',() => quantity.value = Math.min(99,count()+1));
    quantity.addEventListener('change',() => quantity.value = count());
    form.addEventListener('submit',async event => {
      event.preventDefault();
      if (busy || !form.reportValidity()) return;
      const variant = selectedVariant();
      if (!variant?.available) { status.textContent = strings.unavailable; return; }
      if (!window.HorusBondsCart?.open) { status.textContent = strings.error; return; }
      const amount = count();
      setBusy(true);
      try {
        const response = await fetch(form.dataset.addUrl,{
          method:'POST',credentials:'same-origin',headers:{Accept:'application/json','Content-Type':'application/json'},
          body:JSON.stringify({items:[{id:variant.id,quantity:amount,properties:{_horus_bonds:'recommendation'}}]})
        });
        const result = await response.json().catch(() => ({}));
        if (!response.ok) throw new Error(result.description || result.message || strings.error);
        dialog.close();
        setBusy(false);
        quantity.value = '1';
        await window.HorusBondsCart.open(trigger);
      } catch (error) {
        setBusy(false);
        status.textContent = error.message || strings.error;
      }
    });
    sync();
  };
  const boot = () => document.querySelectorAll('[data-hq-card]').forEach(init);
  window.HorusBondsQuickAdd = {boot};
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',boot); else boot();
  document.addEventListener('shopify:section:load',boot);
  document.addEventListener('shopify:section:unload',event => {
    for (const entry of cards) if (event.target.contains(entry.card)) { if(entry.dialog.open)entry.dialog.close();cards.delete(entry); }
    unlock();
  });
  window.addEventListener('pageshow',event => {
    boot();
    if (event.persisted) busy = false;
    for (const item of cards) item.sync();
    unlock();
  });
})();
